import { render, staticRenderFns } from "./FamilyReceiveMessageDetail.vue?vue&type=template&id=3842b150&lang=pug"
import script from "./FamilyReceiveMessageDetail.vue?vue&type=script&lang=ts"
export * from "./FamilyReceiveMessageDetail.vue?vue&type=script&lang=ts"
import style0 from "./FamilyReceiveMessageDetail.vue?vue&type=style&index=0&id=3842b150&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports